export default "__VITE_ASSET__$oKqMf3T__"